module.exports = __webpack_public_path__ + "img/15.00b8e6d9.png";